// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2L6Te","header":"MessagesList_header__3PibD","chat":"MessagesList_chat__3HFOf"};